<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label=label :placeholder=placeholder :hint="hint" :hide-details="hideDetails" item-value="id" item-text="name" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter>

    <template v-slot:selection="data">
        <div class="d-flex align-center text-truncate" style="max-width:150px">
            <v-avatar v-if="data.item.avatar" size="21">
                <img :src="data.item.avatar">
            </v-avatar>
            <span :class="{'pl-2':data.item.avatar}">{{data.item.full_name}}</span>
        </div>
    </template>

    <template v-slot:item="data">
        <v-card tile flat style="background: transparent;">
            <v-avatar v-if="data.item.avatar" size="21">
                <img :src="data.item.avatar" style="width:21px;height:21px;">
            </v-avatar>
            {{data.item.full_name}}
        </v-card>
    </template>

</v-autocomplete>
</template>

<script>
export default {

    props: {
        label: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean
    },

    data() {
        return {
            model: {
                id: null,
                full_name: null,
                avatar: null
            },
            items: [],
            loading: false,
            search: null,
            search_timeout: 300
        }
    },

    watch: {

        search(val) {

            if(this.model && val === this.model.name) {
                return;
            }

            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },

    },

    methods: {

        getItems(val) {

            // quit early if no search value
            if(!val) {
                return
            }

            // loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/users';

            // prepare params
            let options = {
                params: {
                    search: val,
                    fields: ['first_name', 'last_name', 'email'],
                    size: 5
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        }

    }

}
</script>
